<template>
  <div
    v-if="getLength"
    class="d-flex align-center justify-center pa-2"
  >
    <span
      v-if="!display"
      class="text-center"
    >
      {{ getLabel }}
    </span>
    <slot
      name="label"
      :label="getLabel"
    />
  </div>
</template>

<script>

export default {
  name: 'TotalsToRemove',
  data: () => ({
    selects: 0,
    total: 15,
  }),
  computed: {
    getLength() {
      return this.selects;
    },
    getTotal() {
      return this.total;
    },
    getLabel() {
      return this.getLength > 1
        ? `Selecionados ${this.getLength} items de ${this.getTotal}`
        : `Selecionado ${this.getLength} item de ${this.getTotal}`;
    },
    display() {
      return this.$scopedSlots && this.$scopedSlots.label;
    },
  },
  created() {
    this.setData();
  },
  methods: {
    setData() {
      this.handleLength();
      this.handleTotal();
    },
    handleLength() {
      this.$root.$on('selected-all-rows', (rows) => {
        const selects = rows.filter(({ value }) => value === true);

        this.selects = selects.length;
      });
      this.$root.$on('selected-all', (value) => {
        this.selects = value ? this.total : 0;
      });
    },
    handleTotal() {
      this.$root.$on('total-selected', (value) => {
        this.total = value;
      });
    },
  },
};
</script>
